import type { Patient } from "fhir/r5";
import type { MessagingPatient } from "src-next/modules/crm-clinical/messaging";
import {
  getPatientCpf,
  getPatientDisplayName,
  getPatientPhone,
} from "../transformers/wooFormatters";

/**
 * Converte Patient FHIR da lista ecommerce para o contrato do
 * SendWhatsAppMessageDialog (FluxZap desta branch).
 */
export function mapPatientToMessagingPatient(
  patient: Patient,
): MessagingPatient {
  const cpf = getPatientCpf(patient);
  const patientId = patient.id || cpf;

  return {
    id: patientId,
    fullName: getPatientDisplayName(patient),
    cpf: cpf || undefined,
    phone: getPatientPhone(patient) || undefined,
    birthDate: patient.birthDate,
    forReference: patientId ? `Patient/${patientId}` : undefined,
  };
}
